import React from 'react';

import { Icon } from '../icons';

export const PreviewIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M16,6 C9.40909091,6 3.78045455,10.1466667 1.5,16 C3.78045455,21.8533333 9.40909091,26 16,26 C22.5909091,26 28.2195455,21.8533333 30.5,16 C28.2195455,10.1466667 22.5909091,6 16,6 Z M16,22.6666667 C12.3618182,22.6666667 9.40909091,19.68 9.40909091,16 C9.40909091,12.32 12.3618182,9.33333333 16,9.33333333 C19.6381818,9.33333333 22.5909091,12.32 22.5909091,16 C22.5909091,19.68 19.6381818,22.6666667 16,22.6666667 Z M16,12 C13.8118182,12 12.0454545,13.7866667 12.0454545,16 C12.0454545,18.2133333 13.8118182,20 16,20 C18.1881818,20 19.9545455,18.2133333 19.9545455,16 C19.9545455,13.7866667 18.1881818,12 16,12 Z" />
    </svg>
  );
};
